import React from 'react';
import Modal from '../../../../../components/Modal';
import Tag from '../../../../../components/tag/Tag';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import './TagListViewModal.scss';

export const TagListViewModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { tagList } = data;

  return (
    <Modal
      title="태그 보기"
      isOpen={isOpen}
      width={350}
      height={350}
      isFooter={false}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="tag-list-view-modal-wrap">
        {tagList.map((item) => (
          <Tag
            key={item.id}
            text={item.name}
            onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, item.id))}
          />
        ))}
      </div>
    </Modal>
  );
};

export default TagListViewModal;
